import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { BASE_URL } from "../../config/config";


export const UpdateElectricBill = createAsyncThunk(
  "dummyData/UpdateElectricReading",
  async ({ id, formData }, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        `${BASE_URL}/update-electric-reading/${id}`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);





const UpdateElectricReading = createSlice({
    name: "updateElectricReading",
    initialState: {
        loading: false,
        UpdateElectricReading: [],
        error: ""
    },
    extraReducers: {
        [UpdateElectricBill.fulfilled]: (state, action) => {
            state.UpdateElectricReading = action.payload;
            state.loading = false;
        },
        [UpdateElectricBill.pending]: (state) => {
            state.loading = true;
        },
        [UpdateElectricBill.rejected]: (state, action) => {
            state.error = action.error.message;
        },
    }
});
export default UpdateElectricReading.reducer;